<div>
    <div class="buttons">
        <button class="ui button" (click)="goBack()">Précédent</button>
        <button class="ui button" (click)="add()">Ajouter</button>
    </div>
    <div *ngIf="vans.Value().length == 0">
        <h3>Aucun van de ce type</h3>
    </div>
    <admin-van-details *ngFor="let van of vans.Value()"
                       (removed)="remove(van)"
                       (enabled)="enable(van)"
                       (disabled)="disable(van)"
                       [van]="van"></admin-van-details>
    <string-popup (validated)="onPlateValidated($event)"></string-popup>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/leasing/presentation/vanEditComponent/vanEdit.html